import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsNotEmpty, IsString, IsUUID, ValidateNested } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum } from '../interface';
import { PreviewTerminologyDto } from './PreviewTerminologyDto';
export class PreviewLoyaltyProgramDto {
}
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4', example: '5c489c2e-20fa-4fc1-a550-76a3e27e04d9' }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PREVIEW] }),
    IsNotEmpty({ groups: [LoyaltyProgramExposeGroupEnum.READ] }),
    IsString({ groups: [LoyaltyProgramExposeGroupEnum.READ] }),
    IsUUID('4', { groups: [LoyaltyProgramExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], PreviewLoyaltyProgramDto.prototype, "programUuid", void 0);
__decorate([
    ApiProperty({ type: () => PreviewTerminologyDto }),
    Expose({
        groups: [
            LoyaltyProgramExposeGroupEnum.READ,
            LoyaltyProgramExposeGroupEnum.PUT,
            LoyaltyProgramExposeGroupEnum.CREATE,
            LoyaltyProgramExposeGroupEnum.PREVIEW,
        ],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Type(() => PreviewTerminologyDto),
    __metadata("design:type", PreviewTerminologyDto)
], PreviewLoyaltyProgramDto.prototype, "terminology", void 0);
//# sourceMappingURL=PreviewLoyaltyProgramDto.js.map